import * as pluralizeModule from 'pluralize'

// pluralize is CommonJS. The server compiles to CommonJS and gets the function
// straight from require, but the client is bundled as ESM, where a namespace
// import is an uncallable Module Namespace Object. Reach through `default` when
// the bundler adds one.
const pluralize: (word: string) => string =
  (pluralizeModule as unknown as { default?: (word: string) => string })
    .default ?? (pluralizeModule as unknown as (word: string) => string)

export const normalizeTaxonomy = (taxonomy: string): string => {
  const taxonomyIdentifier = taxonomy.replace(/^taxonomies\//, '')
  const kebabCaseTaxonomy = taxonomyIdentifier
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .toLowerCase()

  return pluralize(kebabCaseTaxonomy)
}
